// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page {
  min-height: 100vh;
  background: var(--ui-bg);
  padding: 40px 16px 64px;
  display: flex;
  justify-content: center;
}

.privacy-container {
  width: 100%;
  max-width: 760px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  box-shadow: var(--ui-shadow-sm);
  padding: 40px 48px;
}

.privacy-logo {
  display: block;
  height: 64px;
  margin-bottom: 16px;
}

.privacy-container h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

.privacy-container h2 {
  font-size: 18px;
  margin-top: 32px;
  margin-bottom: 8px;
  color: var(--ui-primary);
}

.privacy-container h3 {
  font-size: 15px;
  margin-top: 20px;
  margin-bottom: 8px;
}

.privacy-container p,
.privacy-container li {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ui-text);
}

.privacy-container ul {
  padding-left: 20px;
  margin-bottom: 12px;
}

.privacy-container li {
  margin-bottom: 6px;
}

.privacy-container a {
  color: var(--ui-primary);
}

.privacy-draft-notice {
  background: var(--ui-input-bg);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.privacy-updated {
  margin-bottom: 8px;
}

.privacy-pending {
  color: var(--Vermelho);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PoliticaPrivacidade/politicaPrivacidade.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":[".privacy-page {\n  min-height: 100vh;\n  background: var(--ui-bg);\n  padding: 40px 16px 64px;\n  display: flex;\n  justify-content: center;\n}\n\n.privacy-container {\n  width: 100%;\n  max-width: 760px;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  box-shadow: var(--ui-shadow-sm);\n  padding: 40px 48px;\n}\n\n.privacy-logo {\n  display: block;\n  height: 64px;\n  margin-bottom: 16px;\n}\n\n.privacy-container h1 {\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n.privacy-container h2 {\n  font-size: 18px;\n  margin-top: 32px;\n  margin-bottom: 8px;\n  color: var(--ui-primary);\n}\n\n.privacy-container h3 {\n  font-size: 15px;\n  margin-top: 20px;\n  margin-bottom: 8px;\n}\n\n.privacy-container p,\n.privacy-container li {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--ui-text);\n}\n\n.privacy-container ul {\n  padding-left: 20px;\n  margin-bottom: 12px;\n}\n\n.privacy-container li {\n  margin-bottom: 6px;\n}\n\n.privacy-container a {\n  color: var(--ui-primary);\n}\n\n.privacy-draft-notice {\n  background: var(--ui-input-bg);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  padding: 14px 16px;\n  font-size: 13px;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.privacy-updated {\n  margin-bottom: 8px;\n}\n\n.privacy-pending {\n  color: var(--Vermelho);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
